<!-- 通用信息提示 -->
<template>
    <transition class="animated animate__fadeInUp">
        <!-- <div class="message" :style="style[type]" v-show="visible"> -->
        <div class="message" v-show="visible" style="width: 265rem;">
            <div class="icon" v-if="type">
                <img v-if="type == 'warn'" src="@/assets/images/common/wait_icon.png">
                <img v-if="type == 'success'" src="@/assets/images/common/success_icon.png">
                <img v-if="type == 'error'" src="@/assets/images/common/warn_icon.png">
            </div>
            <!-- 上面绑定的是样式 -->
            <!-- 不同提示图标会变 -->
            <!-- <i class="iconfont" :class="[style[type].icon]"></i> -->
            <span class="text">
                {{ text }}
            </span>
        </div>
    </transition>
</template>
<script lang="ts">
import { onMounted, ref } from "vue";

export default {
    name: "MessageMain",
    props: {
        text: {
            type: String,
            default: ""
        },
        type: {
            type: String,
            default: ""
        },
    },
    setup() {
        // const router = useRouter();
        // 定义一个对象，包含三种情况的样式，对象key就是类型字符串
        const style: any = {};
        const visible = ref(true);
        onMounted(() => {
            visible.value = true;
        });
        const OneKeyBinding = () => {
            let routenew = location.href.split("#")[0];
            window.location.href = routenew + "#/login?IsOneKey=OneKey";
        };
        return { style, visible, OneKeyBinding };
    }
};
</script>

<style scoped lang="less">
.message {
    position: fixed;
    top: 26%;
    left: 50%;
    transform: translateX(-50%);
    margin: 0 auto;
    padding: 20rem 20rem;
    text-align: center;
    color: #fff !important;
    z-index: 999999;
    min-width: 268rem;
    font-family: "contentFont";
    font-size: 16rem;
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 10rem;

    .icon {
        >img {
            width: 50rem;
        }
    }
    .iconfont {
        font-size: 20rem;
    }
}

/* 动画进入开始时状态 */
.down-enter {
    opacity: 0;
    // transform: translate(-50%, -100%);
}

/* 动画进入过程动画效果 */
.down-enter-active {
    transition: all 3s ease;
}

/* 动画离开开始时状态 */
.down-leave {
    transform: translateY(0%);
}

/* 动画结束时动画 */
.down-leave-to {
    opacity: 0;
    transform: translate(-50%, -100%);
}

/* 动画离开过程动画效果 */
.down-leave-active {
    transition: all 3s ease;
}
</style>
